import React from 'react'
import { Container, Card, Row, Col } from 'react-bootstrap'
import axios from 'axios'
import GoogleLogin from 'react-google-login'

import { Role } from '../../models'
import './index.css'

const Login = () => {
  const handleGoogleLogin = async (data) => {
    if (!data || data.error) return alert(data.error)

    const { accessToken, tokenId: googleTokenId } = data

    axios.defaults.headers.common['Authorization'] = accessToken
    window.localStorage.setItem('token', accessToken)
    window.localStorage.setItem('googleTokenId', googleTokenId)

    const { role } = await Role.get()
    window.localStorage.setItem('role', role)

    window.location.reload()
  }

  return (
    <Container>
      <Row>
        <Col xs={12} sm={12} md={{ span: 6, offset: 3 }}>
          <Card className="login-card mb-3">
            <Col
              xs={{ span: 10, offset: 1 }}
              sm={{ span: 10, offset: 1 }}
              md={{ span: 8, offset: 2 }}
              className="mt-5 mb-5"
            >
              <p className="login-header">Login using your Google account</p>
              <GoogleLogin
                className="google-login-btn mb-4"
                clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                scope="https://www.googleapis.com/auth/classroom.courses.readonly profile email"
                onSuccess={handleGoogleLogin}
                onFailure={handleGoogleLogin}
                fetchBasicProfile={false}
                theme="dark"
              />
              <p>
                <a
                  className="mb-4"
                  href="https://accounts.google.com/signin/recovery"
                >
                  Forgot your password?
                </a>
              </p>
            </Col>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default Login
